var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNh30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.533 4.52179L9.22269 1.68604L14.4613 11.7202L19.6998 1.75875L14.533 4.52179ZM18.5523 5.32157L25.2978 2.55853V7.57563L21.4227 9.32071C23.7191 11.2112 25.2261 14.047 25.2261 17.1736C25.2261 22.8451 20.3463 27.4986 14.3901 27.4986C8.3622 27.4986 3.5542 22.9178 3.5542 17.1736C3.5542 13.9742 5.06118 11.1385 7.50107 9.17528L3.62596 7.4302V2.41311L10.2998 5.24886L11.3762 7.21207L13.8161 11.8656C11.0891 12.2292 9.00805 14.4832 9.00805 17.1736C9.00805 20.082 11.5197 22.4815 14.6054 22.4815C17.6912 22.4815 20.2028 20.1547 20.2028 17.1736C20.2028 14.4105 17.9782 12.0837 15.1078 11.8656L17.4041 7.35749H17.4759L18.5523 5.32157Z",
    fill: "#FFDC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNh30);
export default __webpack_public_path__ + "static/media/NH투자증권-30.bd19260cad228ad0af6c3de33a6174d7.svg";
export { ForwardRef as ReactComponent };